import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useIsNA } from "@RHCommerceDev/hooks/useIsNA";
import { useEnv } from "@RHCommerceDev/hooks/useEnv";
import yn from "yn";

const IGNORE_PATTERNS = ["/my-account", "/checkout", "/gift-registry"];

export const useConstructorBeacon = () => {
  const location = useLocation();
  const isNA = useIsNA();
  const env = useEnv();

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof document === "undefined" ||
      !yn(env?.FEATURE_SR_4702_CONSTRUCTOR)
    ) {
      return;
    }

    const shouldLoadBeacon = !IGNORE_PATTERNS.some(pattern =>
      location.pathname.includes(pattern)
    );

    if (!shouldLoadBeacon || !isNA) {
      const existingScript = document.querySelector(
        'script[src*="cnstrc.com"]'
      );
      if (existingScript) {
        existingScript.remove();
      }
      return;
    }

    const existingScript = document.querySelector('script[src*="cnstrc.com"]');
    if (existingScript) {
      return;
    }

    const script = document.createElement("script");
    script.defer = true;
    script.src = "https://cnstrc.com/js/cust/restoration_hardware_kaBcbE.js";
    script.type = "text/javascript";
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector(
        'script[src*="cnstrc.com"]'
      );
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [location.pathname, isNA, env?.FEATURE_SR_4702_CONSTRUCTOR]);
};
